import React from 'react';
import MegaMenu from './MegaMenu';

const CareerMegaMenu = () => {
  return (
    <>
     {/* <MegaMenu menuName="Career" menuParagraph="Join Unique Technologies, where innovation meets opportunity. Embark on a rewarding career path with a dynamic team dedicated to pushing boundaries and shaping the future of technology. Whether you're an aspiring engineer, creative thinker, or business strategist, we offer an environment that fosters growth, collaboration, and meaningful contributions to our industry-leading projects."  /> */}
    </>
  )
}

export default CareerMegaMenu
